import { useSearchParams } from "react-router-dom";
import { Dropdown, DropdownItem } from "../../common/Dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export const toQueryString = function () {
  let filterParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new URLSearchParams(filterParams).toString();
};
export const SORT_OPTIONS = [{
  label: "Most GTC Staked",
  orderBy: "TOTAL_STAKED_DESC"
}, {
  label: "Most contributors",
  orderBy: "TOTAL_CONTRIBUTORS_DESC"
}, {
  label: "Most donations",
  orderBy: "TOTAL_DONATIONS_DESC"
}, {
  label: "Least GTC Staked",
  orderBy: "TOTAL_STAKED_ASC"
}, {
  label: "Least contributors",
  orderBy: "TOTAL_CONTRIBUTORS_ASC"
}, {
  label: "Least donations",
  orderBy: "TOTAL_DONATIONS_ASC"
}];
const getSortOptionFromUrlParams = params => {
  const orderBy = params.get("orderBy");
  return SORT_OPTIONS.find(option => option.orderBy === orderBy);
};
export function SortDropdown() {
  var _selected$label;
  const [params] = useSearchParams();
  const selected = getSortOptionFromUrlParams(params);
  const pathname = window.location.hash.substring(1);
  return /*#__PURE__*/_jsx(Dropdown, {
    labelClassName: "text-[14px]/[21px] font-normal text-red-500",
    label: (_selected$label = selected === null || selected === void 0 ? void 0 : selected.label) !== null && _selected$label !== void 0 ? _selected$label : "Most GTC Staked",
    options: SORT_OPTIONS,
    renderItem: _ref => {
      let {
        label,
        orderBy,
        close
      } = _ref;
      return /*#__PURE__*/_jsx(DropdownItem, {
        onClick: e => {
          e.preventDefault();
          close();
          // Remove any existing query parameters from pathname
          const basePath = pathname.split("?")[0];
          window.location.hash = `${basePath}?orderBy=${orderBy}`;
        },
        children: label
      });
    }
  });
}